import { render, staticRenderFns } from "./FunctionView.vue?vue&type=template&id=24a89b2a&scoped=true"
import script from "./FunctionView.vue?vue&type=script&lang=js"
export * from "./FunctionView.vue?vue&type=script&lang=js"
import style0 from "./FunctionView.vue?vue&type=style&index=0&id=24a89b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a89b2a",
  null
  
)

export default component.exports